import { render, staticRenderFns } from "./TermsandCondition.vue?vue&type=template&id=0591dd64&scoped=true"
import script from "./TermsandCondition.vue?vue&type=script&lang=js"
export * from "./TermsandCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsandCondition.vue?vue&type=style&index=0&id=0591dd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591dd64",
  null
  
)

export default component.exports